<placeme-layout-seo [seo]="offer?.seo" [category]="offer?.__typename">
  <placeme-jumbotron [seo]="offer?.seo" [category]="offer?.__typename"></placeme-jumbotron>

  <section class="main-content">
    <div class="characteristics">
      <div class="characteristics__item" #revealContainer>
        <img
          class="characteristics__item__illustrations reveal"
          [src]="'offerPage.characteristics.duration.image.url' | translate"
          [alt]="'offerPage.characteristics.duration.label' | translate"
        />
        <div class="characteristics__item__content">
          <p class="characteristics__item__content__title display reveal">{{ offer?.duration }}</p>
          <h2 class="characteristics__item__content__description heading reveal">
            {{ 'offerPage.characteristics.duration.label' | translate }}
          </h2>
        </div>
      </div>
      <div class="characteristics__item characteristics__item--mirror" #revealContainer>
        <img
          class="characteristics__item__illustrations reveal"
          [src]="'offerPage.characteristics.budget.image.url' | translate"
          [alt]="'offerPage.characteristics.budget.label' | translate"
        />
        <div class="characteristics__item__content">
          <p class="characteristics__item__content__title display reveal">{{ offer?.budget }}</p>
          <h2 class="characteristics__item__content__description heading reveal">
            {{ 'offerPage.characteristics.budget.label' | translate }}
          </h2>
        </div>
      </div>
      <div class="characteristics__item" #revealContainer>
        <img
          class="characteristics__item__illustrations reveal"
          [src]="'offerPage.characteristics.team.image.url' | translate"
          [alt]="'offerPage.characteristics.team.label' | translate"
        />
        <div class="characteristics__item__content">
          <p class="characteristics__item__content__title display reveal">{{ offer?.team }}</p>
          <h2 class="characteristics__item__content__description heading reveal">
            {{ 'offerPage.characteristics.team.label' | translate }}
          </h2>
        </div>
      </div>
    </div>
  </section>

  <section class="description">
    <svg preserveAspectRatio="none" viewBox="0 0 1729 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.4782 37.2407L0.998169 21.9019V89.5H1729V21.9019L1632.52 14.2325C1537.48 6.56312 1344.52 -8.77566 1153 6.56312C1067.95 13.375 982.609 26.237 897.24 39.1038C790.378 55.2102 683.466 71.3242 576.998 75.5876C385.478 83.257 192.518 52.5795 97.4782 37.2407Z"
      />
    </svg>
    <div class="description__container">
      <div class="description__container__content">
        <h2 class="description__container__content__title display">{{ offer?.seo?.title }}</h2>
        <markdown class="description__container__content__text heading" [data]="offer?.content | translate"></markdown>
      </div>
    </div>
    <svg preserveAspectRatio="none" viewBox="0 0 1728 97" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 90.8635L96 86.1738C192 80.8978 384 70.9322 576 76.2081C768 80.8978 960 101.415 1152 96.1394C1344 90.8635 1536 60.9665 1632 45.7249L1728 30.4832V0H1632C1536 0 1344 0 1152 0C960 0 768 0 576 0C384 0 192 0 96 0H0V90.8635Z"
      />
    </svg>
  </section>

  <section class="main-content detailCardContainer">
    <h2 class="display detailCardContainer__title">{{ 'offerPage.details.title' | translate }}</h2>

    <div class="detailCard" #revealContainer>
      <div class="detailCard__content">
        <h3 class="detailCard__content__title reveal">{{ 'offerPage.details.deliverables.title' | translate }}</h3>
        <ul class="detailCard__content__list">
          <li *ngFor="let item of offer?.deliverables" class="detailCard__content__list__item reveal">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="detailCard__illustration">
        <img [src]="'offerPage.details.deliverables.image.url' | translate" [alt]="'offerPage.details.deliverables.title' | translate" />
      </div>
    </div>

    <div class="detailCard" #revealContainer>
      <div class="detailCard__content">
        <h3 class="detailCard__content__title reveal">{{ 'offerPage.details.options.title' | translate }}</h3>
        <ul class="detailCard__content__list">
          <li *ngFor="let item of offer?.options" class="detailCard__content__list__item reveal">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="detailCard__illustration">
        <img [src]="'offerPage.details.options.image.url' | translate" [alt]="'offerPage.details.options.title' | translate" />
      </div>
    </div>

    <div class="detailCard" #revealContainer>
      <div class="detailCard__content">
        <h2 class="detailCard__content__title reveal">{{ 'offerPage.details.commitments.title' | translate }}</h2>
        <ul class="detailCard__content__list">
          <li *ngFor="let item of offer?.commitments" class="detailCard__content__list__item reveal">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="detailCard__illustration">
        <img [src]="'offerPage.details.commitments.image.url' | translate" [alt]="'offerPage.details.commitments.title' | translate" />
      </div>
    </div>
  </section>

  <section *ngIf="offer?.showcases?.length" class="main-content example">
    <h2 class="display example__title">{{ 'offerPage.showcases.title' | translate }}</h2>
    <div class="example__container">
      <a class="card" [routerLink]="['/', 'showcase', showcase.slug] | localize" *ngFor="let showcase of offer?.showcases">
        <div class="card__img">
          <img [src]="showcase.seo | seoImageUrl" [alt]="showcase.seo.title" [title]="showcase.seo.title" />
        </div>
        <div class="card__container">
          <h3 class="card__container__title">{{ showcase.seo.title }}</h3>
          <p class="card__container__description">
            {{ showcase.seo.description }}
          </p>
        </div>
      </a>
    </div>
  </section>
  <placeme-meeting></placeme-meeting>
</placeme-layout-seo>
